// extracted by mini-css-extract-plugin
export var dividerLine = "_75-3";
export var itemImage = "_75-9";
export var lightDivider = "_75-4";
export var modalContent = "_75-5";
export var modalContentCompact = "_75-6";
export var productCard = "_75-a";
export var productImage = "_75-b";
export var productImageCompact = "_75-7";
export var productImagePlaceholder = "_75-c";
export var productImagePlaceholderCompact = "_75-8";
export var progressBarBackground = "_75-1";
export var progressBarContainer = "_75-0";
export var progressBarFill = "_75-2";